<template>
  <div class="breadcrumbs">
    <component
      v-for="(item, index) in items"
      :key="index"
      :is="item.to ? 'router-link' : 'div'"
      :to="item.to"
      class="breadcrumbs__item"
    >
      <skeleton-loader v-if="item.loading" width="100px" height="18px" inline />
      <template v-else>
        <e-icon v-if="item.icon" :name="item.icon" size="14" class="mr-1" />
        {{ item.title }}
      </template>

      <e-icon v-if="index < items.length - 1" name="chevronRight" size="9" class="ml-3 mr-2" />
    </component>
  </div>
</template>

<script setup lang="ts">
import type { BreadcrumbsItem } from '@/core/types/components/helps';
import SkeletonLoader from '@/core/components/interface/SkeletonLoader.vue';
import { EIcon } from '@/core/components/ui';

defineProps<{
  items: BreadcrumbsItem[];
}>();
</script>

<style scoped lang="scss">
.breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &__item {
    display: flex;
    align-items: center;

    font-size: 12px;
    color: $text-ordinary-color;

    @include hover {
      text-decoration: underline;
    }

    &:last-child {
      color: $text-secondary-color;

      @include hover {
        text-decoration: none;
      }
    }
  }
}
</style>
